import { useMemo } from "react";
import {
    ResponsiveContainer,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";
import { computeR2 } from "../../../utils/stats";

interface Props {
    points: { x: number; y: number }[];
    relevant: { id: string; name: string }[];
}

export function MultiScatterChart({ points, relevant }: Props) {
    const r2 = useMemo(() => computeR2(points), [points]);

    if (relevant.length !== 2) return null;

    return (
        <div style={{ width: "100%", height: 400, marginTop: "2rem" }}>
            <ResponsiveContainer width="100%" height="100%">
                <ScatterChart>
                    <CartesianGrid />
                    <XAxis type="number" dataKey="x" name={relevant[0].name} domain={["auto", "auto"]} />
                    <YAxis type="number" dataKey="y" name={relevant[1].name} domain={["auto", "auto"]} />
                    <Tooltip cursor={{ strokeDasharray: "3 3" }} animationDuration={0} />
                    <Legend />
                    <Scatter
                        name={`${relevant[0].name} vs ${relevant[1].name} (R² = ${r2.toFixed(3)})`}
                        data={points}
                        fill="var(--chart-series-5)"
                        isAnimationActive={false}
                    />
                </ScatterChart>
            </ResponsiveContainer>
        </div>
    );
}

